<template>
  <div>
    <el-form label-width="80px" label-position="right" ref="cooperationRuleForm" :rules="rules" :model="cooperationForm">
      <el-form-item label="合作意向：">
        <span class="num">找货</span>
      </el-form-item>
      <el-form-item label="找货需求：" prop="majorCategory">
        <div class="main-categories">
          <el-tag v-for="(tag, index) in categoryOptions" :key="tag.id" @close="delMainCategory('single',index)" class="mar-r" type="info" closable>{{tag.name}}</el-tag>
        </div>
        <el-button type="link" @click="editMainCategory">设置需求类目</el-button>
        <el-button type="link" @click="delMainCategory('clear')">清空</el-button>
      </el-form-item>
      <el-form-item
          label="合作模式："
          prop="cooperationMode"
      >
        <el-checkbox-group v-model="cooperationForm.cooperationMode">
          <el-checkbox :label="'1'" name="type">一件代发</el-checkbox>
          <el-checkbox :label="'2'" name="type">批量采购</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
    </el-form>
    <EditMainCategoryDialog
        title="设置需求类目"
        ref="editMainCategoryDialog"
        identity="myDistributorCard"
    />
  </div>
</template>

<script>
import {getFindgoodscategory} from "@servers/prod/center";
import EditMainCategoryDialog from '@/components/prod/center/dialogs/EditMainCategoryDialog.vue'

export default {
  props: {
    editCooperationFrom: {
      type: Object,
      default: ()=> {
        return {
          cooperationMode: [], // 合作模式 1: 一件代发、 2:批量采购 - 可多选，逗号分隔
        }
      }
    }
  },
  data() {
    return {
      cooperationForm: {
        cooperationMode: [],
      },
      rules:{
        cooperationMode: [
          { type: 'array', required: true, message: '请至少选择一个合作模式', trigger: 'change' }
        ]
      },
      mainCategoryList: [],
      categoryOptions: [],
    }
  },
  components: {
    EditMainCategoryDialog
  },
  watch: {
    editCooperationFrom: {
      handler(v) {
        this.$set(this, 'cooperationForm', {...v})
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
  },
  created() {
  },
  mounted() {
    this.getCategoryList();
  },
  methods: {
    method_getFormData() {
      return new Promise((resolve, reject) => {
        this.$refs.cooperationRuleForm.validate(valid => {
          if(valid) {
            let cooperationMode = this.cooperationForm.cooperationMode.join(',')

            resolve({
              ...this.cooperationForm,
              cooperationMode,
              categoryList: this.categoryOptions.map(elem => {
                return {
                  cid: elem.cid,
                  parentCid: elem.parentCid
                }
              })
            });
          } else {
            resolve(false)
          }
        })
      })
    },
    method_reset(){
      this.$refs.cooperationRuleForm.resetFields()
    },
    async delMainCategory(type, index) {
      if(type == 'single') {
        const list = [...this.categoryOptions]
        list.splice(index, 1);
        this.categoryOptions = list;
      } else {
        this.categoryOptions = [];
      }
    },
    editMainCategory() {
      this.$refs.editMainCategoryDialog.method_open(this.categoryOptions, ({
        data,
        showData,
      }) => {
        this.categoryOptions = showData;
      })
    },
    async getCategoryList() {
      let res = await getFindgoodscategory();
      this.categoryOptions = res;
    }
  }
}
</script>

<style lang="scss" scoped>
.num {
  margin-right: 20px;
  font-weight: bold;
}
.title {
  margin-right: 20px;
}
.tips{
  padding-left: 20px;
  color: #B8B8B8;
}
.main-categories {
  display: inline-block;
  width: 80%;
  min-height: 88px;
  padding: 5px 10px;
  color: #333;
  background-color: #FFF;
  border: 1px solid #DCDFE6;
  border-radius: 2px;
  transition: border-color .2s cubic-bezier(.645,.045,.355,1)
}
.mar-r{
  margin-right: 10px;
  margin-bottom: 10px;
}
</style>